export const SHADE_LIGHTNESS: Record<number, number> = {
    25: 98,
    50: 96,
    100: 92,
    200: 86,
    300: 78,
    400: 68,
    500: 58,
    600: 50,
    700: 43,
    800: 36,
    900: 30,
};
